import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layouts/layout.component';
import { AuthGuard } from './core/guards/auth.guard';
import { CoverComponent } from './account/auth/signup/cover/cover.component';

const routes: Routes = [
	{
		path: '',
		component: LayoutComponent,
		loadChildren: () => import('./views/views.module').then((m) => m.ViewsModule),
		canActivate: [AuthGuard],
	},
	{
		path: 'auth',
		loadChildren: () => import('./account/account.module').then((m) => m.AccountModule),
	},
	{
		path: 'pages',
		loadChildren: () => import('./extraspages/extraspages.module').then((m) => m.ExtraspagesModule),
		canActivate: [AuthGuard],
	},
	{
		path: 'landing',
		loadChildren: () => import('./landing/landing.module').then((m) => m.LandingModule),
	},
	{
		path: 'auth2/signup/cover/:email', // Nueva ruta
		component: CoverComponent, // Componente asociado
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
